import { render, staticRenderFns } from "./qna-form.vue?vue&type=template&id=4fa67cd0&"
import script from "./qna-form.vue?vue&type=script&lang=js&"
export * from "./qna-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports